"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UiConfigSchema = exports.TaskSchema = void 0;
const zod_1 = require("zod");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
exports.TaskSchema = zod_1.z.discriminatedUnion('mode', [
    tape_sanitizer_1.Xlsx2Csv2TransformationConvertRangeSchema.omit({
        srcDataTape: true,
    }).extend({
        srcArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Source (input) artifact slug for this operation'),
    }),
    tape_sanitizer_1.Xlsx2Csv2TransformationExtractValuesSchema.omit({
        srcDataTape: true,
    }).extend({
        srcArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Source (input) artifact slug for this operation'),
    }),
]);
exports.UiConfigSchema = zod_1.z.discriminatedUnion('mode', [
    tape_sanitizer_1.Xlsx2Csv2TransformationConvertRangeSchema.omit({
        srcDataTape: true,
    }),
    tape_sanitizer_1.Xlsx2Csv2TransformationExtractValuesSchema.omit({
        srcDataTape: true,
    }),
]);
exports.nodeType = 'operation_xlsx2csv2';
//# sourceMappingURL=types.js.map